module.exports = __webpack_public_path__ + "static/media/ECOODENTIST.83333926.png";